/**
 * Labstep
 *
 * @module components/Entity/Sortable/Table
 * @desc Entity Sortable Table
 */

import { EntitySortableContainer } from 'labstep-web/components/Entity/Sortable';
import { SortableTable } from 'labstep-web/core/Sortable/Table';
import type React from 'react';
import type { EntitySortableTableProps } from './types';

export const EntitySortableTable: React.FC<
  EntitySortableTableProps
> = ({ entityName, disabled, ...rest }) => (
  <EntitySortableContainer
    entityName={entityName}
    disabled={disabled}
    render={(props) => <SortableTable {...props} {...rest} />}
  />
);
